import { useCallback } from 'react';
import styles from './ExpandableHeader.module.css';
import { assets } from '@round/whitelabel-ui';

const { ChevronDown: ChevronDownIcon } = assets;

type ExpandableHeaderProps = {
    isExpanded: boolean;
    onToggle: () => void;
    headerText: string;
    className?: string;
};

export const ExpandableHeader = ({ isExpanded, onToggle, headerText, className }: ExpandableHeaderProps) => {
    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent) => {
            if (['Enter', ' ', 'Spacebar'].includes(e.key)) {
                e.preventDefault();
                onToggle();
            }
        },
        [onToggle]
    );

    return (
        <div
            className={className}
            onClick={onToggle}
            role="button"
            tabIndex={0}
            aria-expanded={isExpanded}
            onKeyDown={handleKeyDown}
        >
            <div className={styles.headerContent}>
                <ChevronDownIcon className={`${styles.chevron} ${isExpanded ? styles.chevronExpanded : ''}`} />
                <span className={styles.headerText}>{headerText}</span>
            </div>
        </div>
    );
};
